import React from 'react';
import { SvgIcon } from 'core/icons';

const SummaryNav = props => {
  const { ctas, onShowSpeedBump } = props;

  const doSpeedBumpCheck = (event, cta) => {
    if (cta.speedBump) {
      event.preventDefault();
      onShowSpeedBump(cta);
    }
  };

  const callToActions = ctas.map(cta => {
    const callToActionClassName = `button button--flex summary-nav__button stat-button-link ${
      cta.primary ? 'button--primary' : 'button--secondary'
    }`;
    return (
      <a
        key={cta.label}
        onClick={e => doSpeedBumpCheck(e, cta)}
        href={cta.url}
        target={`${cta.openNewWindow ? '_blank' : ''}`}
        className={callToActionClassName}
        data-dtm={cta.label}>
        {cta.icon ? <SvgIcon name={cta.icon} className="button__icon" /> : null}
        <div className="button__text">{cta.label}</div>
      </a>
    );
  });

  return <div>{callToActions}</div>;
};

export default SummaryNav;
